import 'core-js'
import Vue from 'vue'
import Page from './Top.vue'
import 'normalize.css'
import '@/assets/css/main.scss';
import '@/assets/js/common.js';
import VueYoutube from 'vue-youtube'
import VueKinesis from 'vue-kinesis'
import VueWindowSize from 'vue-window-size';
 
Vue.use(VueWindowSize);
Vue.use(VueKinesis)
Vue.use(VueYoutube)

Vue.config.productionTip = false

new Vue({
  render: h => h(Page),
}).$mount('#app');

